import { fromJS } from 'immutable';

export const getDiscussionId = state => state.discussion.get('discussionId');
export const getDiscussionName = state => state.discussion.get('name');
export const getMessageListQuery = state => state.discussion.get('messageListQuery');
export const getCurrentBrief = state => state.discussion.get('currentBrief');
export const getCurrentContract = state => state.discussion.get('currentContract');
export const getSignedContract = state => state.discussion.get('signedContract');
export const getDeliverableObject = (state, deliverableId) => state.discussion.getIn(['deliverables', deliverableId]);
export const getDeliverableName = (state, deliverableId) => state.discussion.getIn(['deliverables', deliverableId, 'title']);

export const getDiscussionMembers = (state) => {
  const members = state.members.get('members');
  const organisations = state.discussion.get('organisations');

  const currentMembers = [];
  if (members && members.size > 0 && organisations) {
    members.forEach(member => {
      const userInDiscussion = organisations.find(organisation => {
        return member.getIn(['organisation', 'id']) === organisation.get('id');
      });
      if (userInDiscussion) currentMembers.push(member);
    });
  }
  return fromJS(currentMembers);
};

export const getAddedDeliverables = state => {
  const deliverables = state.discussion.get('deliverables');
  const addedDeliverables = {};
  deliverables.forEach(deliverable => {
    const deliverableDocuments = deliverable.get('documents');
    if (deliverableDocuments && deliverableDocuments.first()) {
      addedDeliverables[deliverable.get('id')] = deliverable;
    }
    else if (deliverable.get('document')) addedDeliverables[deliverable.get('id')] = deliverable;
  });
  return fromJS(addedDeliverables);
};

export const getApprovedDeliverables = state => {
  const deliverables = state.discussion.get('deliverables');
  const approvedDeliverables = {};
  deliverables.forEach(deliverable => {
    const deliverableDocuments = deliverable.get('documents');
    if (deliverableDocuments && deliverableDocuments.first()) {
      if (deliverableDocuments.find(document => document.get('approved') === true)) {
        approvedDeliverables[deliverable.get('id')] = deliverable;
      }
    }
    else if (deliverable.getIn(['document', 'approved'])) approvedDeliverables[deliverable.get('id')] = deliverable;
  });
  return fromJS(approvedDeliverables);
};



/** WEBPACK FOOTER **
 ** ./src/selectors/discussion-selectors.js
 **/